// Dashboard Users rankings page translations (en-US), loaded into dashboard.users.rankings by ../en-US.users.js
module.exports = {
  menu: "Rankings",
  title: "Rankings",
  description: "Top users per criterion and who grew the most in the period.",
  criteria: {
    created: "Events created",
    shared: "Events shared",
    followers: "Followers",
    invites: "Invites sent",
    checkins: "Check-ins",
    engagement: "Engagement",
    time: "Usage time",
  },
  columns: {
    rank: "#",
    user: "User",
    city: "City",
    period: "In the period",
    minutes: "Minutes",
  },
  user: "ID {id}",
  username: "@{username}",
  growth: "+{value}%",
  panels: {
    top: "Top users — {criterion}",
    topNote: "Visible to admins only. Only the @ and the city of the profile, no other personal data.",
    risers: "Who grew the most",
  },
  panelInfo: {
    top: "Users with the highest total in the selected criterion, in the period.\nSource: Firebase (events, shares, followers, invites, “I'm going”, views and activity log).",
    risers: "Users whose total grew the most vs. the previous period.\nSource: Firebase (the same counts as the top).",
  },
};
